import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import './packingLaundry.css';

function ReportLHStain() {
    const [category, setCategory] = useState(null); // 'LH' or 'MDL'
    const [properties, setProperties] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [laundryItems, setLaundryItems] = useState([]);
    const [newReport, setNewReport] = useState({ type: '', item: null, description: '', photo: null });
    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);

    const fetchProperties = async (selectedCategory) => {
        if (!selectedCategory) return;
        const endpoint = selectedCategory === 'LH'
            ? '/api/laundry/properties-lh'
            : '/api/laundry/properties-mdl';

        try {
            const res = await axios.get(endpoint);
            setProperties(res.data.map(p => ({
                value: p.property_id,
                label: `#${String(p.property_id).padStart(3, '0')} - ${p.client_display_name} - ${p.building_name} - Unit ${p.unit_number}`,
                ...p // includes latest_booking_id
            })));
        } catch (error) {
            console.error("Failed to fetch properties:", error);
        }
    };

    useEffect(() => {
        setSelectedProperty(null);
        if (category) {
            fetchProperties(category);
        }
    }, [category]);

    useEffect(() => {
        const fetchLaundryItems = async () => {
            try {
                const res = await axios.get('/api/laundry/laundry-items');
                setLaundryItems(res.data.map(item => ({
                    value: item.id,
                    label: item.name
                })));
            } catch (error) {
                console.error("Failed to fetch laundry items:", error);
                setLaundryItems([]);
            }
        };
        fetchLaundryItems();
    }, []);

    const handleNewReportChange = (field, value) => {
        setNewReport(prev => ({ ...prev, [field]: value }));

        // Only reset file input if field is NOT 'photo'
        if (field !== 'photo' && fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };


    const closeFeedbackOverlay = () => {
        setFeedbackMessage('');
    };

    const handleUploadReport = async () => {
        if (!selectedProperty || !selectedProperty.latest_booking_id || !newReport.type || !newReport.item || !newReport.photo) {
            setFeedbackMessage("Please complete all fields before uploading.");
            return;
        }

        const formData = new FormData();
        formData.append('photos', newReport.photo);
        formData.append('laundry_item_id', newReport.item.value);
        formData.append('description', newReport.description);

        try {
            setLoading(true);
            await axios.post(
                `/api/attachments/laundry/report-lh-stain/${selectedProperty.latest_booking_id}/${newReport.type}?category=${category}`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            setCategory(null);
            setSelectedProperty(null);
            setNewReport({ type: '', item: null, description: '', photo: null });
            if (fileInputRef.current) fileInputRef.current.value = null;
            setFeedbackMessage("Report uploaded successfully.");
        } catch (error) {
            console.error("Upload failed:", error);
            setFeedbackMessage("Failed to upload report. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="packing-process-container">
            {(loading || feedbackMessage) && (
                <div className="loading-overlay">
                    <div className="loading-box">
                        {loading ? (
                            <>
                                <div className="spinner"></div>
                                <p>Uploading...</p>
                            </>
                        ) : (
                            <>
                                <p>{feedbackMessage}</p>
                                <button className="ok-button" onClick={closeFeedbackOverlay}>
                                    OK
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}

            <h2>Report LH & MDL Laundry Stains or Damages</h2>

            <div className="report-item">

                {/* Category Selector */}
                <Select
                    options={[
                        { value: 'LH', label: 'Linen Hire' },
                        { value: 'MDL', label: 'MDL' }
                    ]}
                    value={category ? { value: category, label: category === 'LH' ? 'Linen Hire' : 'MDL' } : null}
                    onChange={(selected) => setCategory(selected.value)}
                    placeholder="Select Category"
                    className="select-field"
                />

                {/* Property Selector */}
                <Select
                    options={properties}
                    value={selectedProperty}
                    onChange={setSelectedProperty}
                    placeholder="Select Property by ID"
                    className="select-field"
                    isDisabled={!category}
                    filterOption={(option, inputValue) =>
                        option.data.value.toString().padStart(3, '0').includes(inputValue)
                    }
                />

                {/* Item Selector */}
                <Select
                    options={laundryItems}
                    value={newReport.item}
                    onChange={(selected) => handleNewReportChange('item', selected)}
                    placeholder="Select Item"
                    className="select-field"
                    isDisabled={!selectedProperty}
                    isSearchable
                // no sorting override — preserves original order
                />

                {/* Type Selector */}
                <Select
                    options={[
                        { value: 'stain', label: 'Stain' },
                        { value: 'damage', label: 'Damage' }
                    ]}
                    value={newReport.type ? { value: newReport.type, label: newReport.type.charAt(0).toUpperCase() + newReport.type.slice(1) } : null}
                    onChange={(selected) => handleNewReportChange('type', selected.value)}
                    placeholder="Select Type"
                    className="select-field"
                />

                {/* Description and File Upload */}
                <input
                    type="text"
                    placeholder="Description"
                    value={newReport.description}
                    onChange={(e) => handleNewReportChange('description', e.target.value)}
                    className="text-field"
                />

                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={(e) => handleNewReportChange('photo', e.target.files[0])}
                    className="file-field"
                />


                <button type="button" onClick={handleUploadReport} className="submit-report">
                    Upload Report
                </button>
            </div>
        </div>
    );
}

export default ReportLHStain;
